import { CHANNEL_META, type Channel } from 'components'

/** Brand color for a channel — used for the MiniCalendar dot accents. */
export function getChannelConfig(channel?: string) {
  const meta = CHANNEL_META[(channel ?? 'instagram') as Channel] ?? CHANNEL_META.instagram
  return { color: meta.color }
}
